import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DESKTOP_MIN_WIDTH_PX } from '../../../../shared/utils/vessel-sprite';
import { ANDROID_STORE_URL, IOS_STORE_URL } from '../../../../shared/utils/store-links';

/** Corner card on desktop asking people to get the mobile app. Closing it hides it for good (per browser). */
@Component({
  selector: 'app-download-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-download-popup.component.html',
  styleUrl: './app-download-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppDownloadPopupComponent implements OnInit {
  @Input() dismissKey = 'vm_home_download_popup_dismissed';

  readonly iosUrl = IOS_STORE_URL;
  readonly androidUrl = ANDROID_STORE_URL;
  visible = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    // Phones already get the store banner (app-app-banner); this card is for desktop only.
    if (window.innerWidth < DESKTOP_MIN_WIDTH_PX) return;
    try {
      if (localStorage.getItem(this.dismissKey)) return;
    } catch { /* storage blocked: show it, dismiss lasts for this page view only */ }
    this.visible = true;
  }

  dismiss(): void {
    this.visible = false;
    try {
      localStorage.setItem(this.dismissKey, '1');
    } catch { /* storage blocked */ }
    this.cdr.markForCheck();
  }
}
